// fcm.js
import { getToken, onMessage, getMessaging } from "firebase/messaging";
import { app } from "../firebase"; // import only app
import { toast } from "react-toastify";
import axios from 'axios';
import {PUSH_NOTIFICATION_SAVE_FCM_TOKEN} from '../constants';



// ✅ define messaging here, not in firebase.js
export const messaging = getMessaging(app);

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

export const getFCMToken = async (id) => {
  try {
    if(!id){
         console.warn("⚠️ getFCMToken called without user id");
         return null;
    }

    // this block i have added to take notification permission from user--------------
    //------------
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("⚠️ Notification permission not granted");
      return null;
    }
    
       if (!VAPID_KEY) {
      console.error("❌ Missing VAPID_KEY in .env");
      return null;
    }

    //--------------


    const currentToken = await getToken(messaging, { vapidKey: VAPID_KEY });

    if (currentToken) {
      const storedToken = localStorage.getItem("fcmToken") || null;
      console.log("✅ FCM Token stored");
      // console.log("✅ FCM Token stored to see uncomment code:", currentToken);L
      if(currentToken !== storedToken){
         console.log("🔄 New FCM token generated:", currentToken);
         localStorage.setItem("fcmToken", currentToken);
         try {
           await axios.post(PUSH_NOTIFICATION_SAVE_FCM_TOKEN, {
           userId: id,
           token: currentToken,
    });
         } catch (apiError) {
           console.error("❌ Failed to save FCM token to server:", apiError);
         }
      }
      else{
         console.log("✅ Existing FCM token still valid");
      }
      localStorage.setItem("fcmToken", currentToken);
      return currentToken;
    } else {
      console.warn(
        "⚠️ No registration token available. Request permission to generate one."
      );
      return null;
    }
  } catch (err) {
    console.error("❌ Error retrieving token:", err);
    return null;
  }
};

export const checkToken = async () => {

    try {
       if (!VAPID_KEY) {
      console.error("❌ Missing VAPID_KEY in .env");
      return;
    }
    const newToken = await getToken(messaging, { vapidKey: VAPID_KEY });
    const oldToken = localStorage.getItem("fcmToken");
    const userData = JSON.parse(localStorage.getItem("userData")|| "{}");
    
    
    if (!userData?.EmployeeId) {
      console.warn("⚠️ No EmployeeId found in localStorage userData");
      return;
    }

     
    if (newToken && newToken !== oldToken) {
      console.log("🔄 Token rotated:", newToken);
      localStorage.setItem("fcmToken", newToken);
   
      try {
        await axios.post(PUSH_NOTIFICATION_SAVE_FCM_TOKEN, {
        userId: userData?.EmployeeId,
        token: newToken,
      });
      } catch (apiErr) {
       console.error("❌ Failed to update FCM token on server:", apiErr);
      }
    }
  
  } catch (error) {
       console.error("❌ Error checking token:", error);
    }

     
 
  
  };

// THIS CODE BELOW WAS ONLY LISTENING NOTIFICATION ONCE------------->

// export const onMessageListener = () =>
//   new Promise((resolve) => {
//     onMessage(messaging, (payload) => {
//       console.log("📩 Foreground message received:", payload);
//       resolve(payload);
//     });
//   });

// THIS WILL LISTEN EVERY NOTIFICATION ------------>


export const onMessageListener = (callback) => {
  return onMessage(messaging, (payload) => {
    console.log("📩 Foreground message received:", payload);
    callback(payload);
  });
};
